import { render, staticRenderFns } from "./brandinfo.vue?vue&type=template&id=b892a516&scoped=true&"
import script from "./brandinfo.vue?vue&type=script&lang=js&"
export * from "./brandinfo.vue?vue&type=script&lang=js&"
import style0 from "./brandinfo.vue?vue&type=style&index=0&id=b892a516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b892a516",
  null
  
)

export default component.exports